export default {"src":"/_next/static/media/pinterest.92f94073.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};